import moment from 'moment';
import { REGROUPEMENT } from '@/configuration/devisConf';
import { CATEGORIE_REGROUPEMENT } from '@/configuration/catalogue/produitConf';
import getDateWithAnneeSemaineAndJourDepart
  from '@/services/general/getDateWithAnneeSemaineAndJourDepart';

export default function calculDatePremiereAffichage(lignesCommande) {
  let datePremiereAffichage = null;
  lignesCommande.forEach((ligne) => {
    if (ligne.type !== REGROUPEMENT || !ligne.typeProduit) return;
    if (ligne.typeProduit === CATEGORIE_REGROUPEMENT) {
      const dateLigne = getDateWithAnneeSemaineAndJourDepart(
        ligne.ligneReseau.anneeSemaine, ligne.ligneReseau.jourDepart,
      );
      if (!datePremiereAffichage || moment(dateLigne).isBefore(moment(datePremiereAffichage))) {
        datePremiereAffichage = moment(dateLigne);
      }
    } else if (!datePremiereAffichage
      || moment(ligne.dateDebut).isBefore(moment(datePremiereAffichage))) {
      datePremiereAffichage = moment(ligne.dateDebut);
    }
  });
  return datePremiereAffichage;
}
